import { render, staticRenderFns } from "./CheckInformation.vue?vue&type=template&id=f30952fc&"
import script from "./CheckInformation.vue?vue&type=script&lang=ts&"
export * from "./CheckInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports